/* global contentLoaded, pageChange */

const customerAddressForm = () => {
  const newAddressForm = document.getElementById('AddressNewForm');

  if (!newAddressForm) {
    return;
  }

  if (Shopify) {
    // eslint-disable-next-line no-new
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew',
    });
  }

  const countrySelector = document.querySelector('#AddressCountryNew');
  const countryOptions = document.querySelectorAll('#AddressCountryNew option');
  const countrySelector2 = document.querySelectorAll('.address-country-option');
  const countrySelector2Options = document.querySelectorAll('.address-country-option option');

  if(countryOptions.length === 1) {
    let countryContainer = document.createElement("div");
    countryContainer.innerText = countryOptions[0].innerText;
    countryContainer.classList.add("only-country-field");
    countrySelector.after(countryContainer);
  } else {
    countrySelector.classList.remove("hidden");
  }
  
  if(countrySelector2Options.length === countrySelector2.length) {
    let countryContainer2 = document.createElement("div");
    countryContainer2.innerText = countrySelector2Options[0].innerText;
    countryContainer2.classList.add("only-country-field");
    countrySelector2.forEach(element => {
      const temp_container = countryContainer2.cloneNode(true);
      element.after(temp_container);
    });
  } else {
    Object.keys(countrySelector2).forEach(index => {
      countrySelector2[index].classList.remove("hidden");
    });
  }

  const addressCountryOption = document.querySelectorAll('.address-country-option');

  addressCountryOption.forEach((countryOption) => {
    const { formId } = countryOption.dataset;
    const countrySelector = `AddressCountry_${formId}`;
    const provinceSelector = `AddressProvince_${formId}`;
    const containerSelector = `AddressProvinceContainer_${formId}`;

    // eslint-disable-next-line no-new
    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector,
    });
  });

  const addAddressForm = document.querySelector('.address-modal-toggle');

  const modalClose = document.querySelector('#modal-addAddress .modal-close');

  addAddressForm.addEventListener('click', () => {
    modalClose.click();
  });

  const editAddress = (editAddressForm) => {
    const { formId } = editAddressForm.dataset;
    const editmodalClose = document.querySelector(`#modal-editAddress_${formId} .modal-close`);

    if (editmodalClose) {
      editmodalClose.click();
    }
  };

  const editAddressForms = document.querySelectorAll('.address-edit-modal-toggle');

  editAddressForms.forEach((editAddressForm) => {
    editAddressForm.addEventListener('click', () => editAddress(editAddressForm));
  });

  const deleteAddressCancel = (deleteAddressForm) => {
    const { formId } = deleteAddressForm.dataset;
    const deletemodalClose = document.querySelector(`#modal-delAddress_${formId} .modal-close`);

    if (deletemodalClose) {
      deletemodalClose.click();
    }
  };

  const deleteAddressForms = document.querySelectorAll('.address-delete-modal-toggle');

  deleteAddressForms.forEach((deleteAddressForm) => {
    deleteAddressForm.addEventListener('click', () => deleteAddressCancel(deleteAddressForm));
  });

  const setDefaultFormElement = (checkbox) => {
    if (checkbox.checked) {
      checkbox.form.submit();
    }
  };
  const checkboxes = document.querySelectorAll('.defaultCheckBox');

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', () => setDefaultFormElement(checkbox));
  });

  const deleteAddress = (address) => {
    const { formId } = address.dataset;

    const data = new URLSearchParams();

    data.append('_method', 'delete');

    const addressWrapper = document.getElementById(`address_${formId}`);
    let fetchUrl = `/account/addresses/${formId}`;

    if (document.documentElement.lang === 'es') {
      fetchUrl = `/es/account/addresses/${formId}`;
    }

    addressWrapper.classList.add('loading');
    fetch(fetchUrl, {
      method: 'POST',
      body: data,
    })
      .then((response) => response.text()).then((response) => {
        const htmlString = response;
        const html = new DOMParser().parseFromString(htmlString, 'text/html');
        const addressWrapperElement = html.querySelector('.addresslisting');
        const addressContainer = document.querySelector('.address-wrapper');
        const deletemodalCloseBtn = document.querySelector(`#modal-delAddress_${formId} .modal-close`);

        if (deletemodalCloseBtn) {
          deletemodalCloseBtn.click();
        }

        if (addressWrapperElement) {
          const addressClone = addressWrapperElement.cloneNode(true);
          const addressContent = addressContainer.querySelector('.addresslisting');

          addressContainer.replaceChild(addressClone, addressContent);
        }

        addressWrapper.classList.remove('loading');
        contentLoaded();
        pageChange();
        customerAddressForm();
      })
      .catch((error) => {
        throw error;
      });
  };

  const deleteAddressForm = document.querySelectorAll('.address-delete');

  deleteAddressForm.forEach((address) => {
    address.addEventListener('click', () => deleteAddress(address));
  });
};

customerAddressForm();
